import React from 'react'
import PropTypes from 'prop-types'
import TermAndConditionAgreementStatusLabel from '../../pages/shared/TermAndConditionAgreementStatusLabel'
import { AGREEMENT_STATUS } from '../../pages/create-terms-and-condition-agreement/constants'
import styles from './TermsAndConditionAgreementStatus.module.scss'

export default function TermsAndConditionAgreementStatus ({ status, onStatusChange, disabled }) {
  return (
    <div className={styles.statusContainer}>
      <div>
        <div className={styles.currentStatus}>Current Status:</div>
        <TermAndConditionAgreementStatusLabel status={status} />
      </div>
      {status === AGREEMENT_STATUS.ENABLED && (
        <button
          type='button'
          className='dis-btn dis-btn-danger dis-btn-sm'
          disabled={disabled}
          onClick={() => onStatusChange(AGREEMENT_STATUS.DISABLED)}>
          <strong>Disable</strong>
        </button>
      )}
      {status === AGREEMENT_STATUS.DISABLED && (
        <button
          type='button'
          className='dis-btn dis-btn-success dis-btn-sm'
          disabled={disabled}
          onClick={() => onStatusChange(AGREEMENT_STATUS.ENABLED)}>
          <strong>Enable</strong>
        </button>
      )}
    </div>
  )
}

TermsAndConditionAgreementStatus.propTypes = {
  status: PropTypes.oneOf(Object.values(AGREEMENT_STATUS)).isRequired,
  onStatusChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}
